
<div>
  <div>
    <button matIconButton (click)="moveToTop()" matTooltip="Move to Top" [matTooltipPosition]="'above'">
      <mat-icon class="material-icons-outlined toolbar-column-icon" fontIcon="keyboard_double_arrow_up"></mat-icon>
    </button>
    <button matIconButton (click)="moveUp()" matTooltip="Move Up" [matTooltipPosition]="'above'">
      <mat-icon class="material-icons-outlined toolbar-column-icon" fontIcon="keyboard_arrow_up"></mat-icon>
    </button>
    <button matIconButton (click)="moveDown()" matTooltip="Move Down" [matTooltipPosition]="'above'">
      <mat-icon class="material-icons-outlined toolbar-column-icon" fontIcon="keyboard_arrow_down"></mat-icon>
    </button>
    <button matIconButton (click)="moveToBottom()" matTooltip="Move to Bottom" [matTooltipPosition]="'above'">
      <mat-icon class="material-icons-outlined toolbar-column-icon" fontIcon="keyboard_double_arrow_down"></mat-icon>
    </button>
  </div>

  <div>
    <mat-list class="lt-list mt-20"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        [cdkDropListData]="reorderedColumns">
      @for (col of reorderedColumns; track col) {

        <mat-list-item
          class="lt-list-item"
          [class.selected]="selectedColumn === col"
          cdkDrag
          [cdkDragData]="col" (click)="selectItem(col)">

          <div class="d-flex flex-row justify-content-center align-items-center">
              <div>
                  <mat-checkbox
                  class="item-checkbox"
                  [checked]="!col.hidden"
                  (change)="col.hidden = !col.hidden"
                  (click)="$event.stopPropagation()"></mat-checkbox>
              </div>

              <div class="lt-list-item-content item-content">
                {{col.title || col.field}}
              </div>

              <div class="w-10 drag-icon">
                <i class="material-icons" cdkDragHandle>reorder</i>
              </div>

            </div>

        </mat-list-item>
      }

    </mat-list>
  </div>

  <div class="mt-2">
    <button matButton="elevated" (click)="reset()">Reset</button>
    <button matButton="elevated" color="success" (click)="apply()">Apply</button>
    <button matButton="elevated" (click)="cancel()">Cancel</button>
  </div>
</div>
